var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"width":"100%","type":"radialBar","options":_vm.parseOptions,"series":[_vm.value]}})}
var staticRenderFns = []

export { render, staticRenderFns }